<template>
    <div id="sqChioce">
        <top :title="title" :type="errortype"></top>
        <div ref="above">
            <div class="setFix"></div>
            <!-- 搜索按钮 -->
            <div class="line1"></div>
            <div class="searchBox" @click="intoSearch">
                点击搜索您的小区
            </div>
            <!-- <p class="title">选择现在居住的社区</p> -->
            <!-- <p class="cur">当前选择的社区</p> -->
            <p class="can">
                您可能在这个小区
                <!-- <span v-if="loaded">
                    location: lng = {{ lng }} lat = {{ lat }}
                </span>
                <span v-else>正在定位</span> -->
            </p>
            <ul class="nowRoom">
                <li>
                    <p class="title1 ">
                        <span class="title2 nowrap">{{name}} </span>
                        <a href="javascript:;" class="rep" @click="position">重新定位</a>
                    </p>
                    <a href="javascript:;" v-if="address.length!=0" class="address">{{city}}{{area}}{{address}}</a>
                </li>
            </ul>
            <!-- <p class="cur">周边小区</p> -->
            <p class="can nearby">附近的小区推荐</p>
        </div>
        <div class="aroundWrap" :style="{height: aroundWrapHeight + 'px'}">
            <div class="onetag" ref="onetag"
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="disabled"
                infinite-scroll-distance="0">
                <ul class="nowRoom aroundRoom">
                    <li v-for="(item,i) in aroundList" :key="i" @click="goBack(item)">
                        <p class="title1">{{item.name}}</p>
                        <a href="javascript:;" v-if="item.address.length!=0" class="address">{{item.cityname}}{{item.adname}}{{item.address}}</a>
                    </li>
                    <li ref="bottom" v-if="!isFoot" style="display: block;text-align: center;border-bottom:0;"></li>
                </ul>
                <!-- <div class="isfoot" v-show="isFoot"> 我已经到底了...</div> -->
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Top from "@/component/top/top";
import { Indicator, Toast } from "mint-ui";
import { location } from "@/location.js";
import AMap from "vue-amap";
export default {
  data() {
    return {
      aroundList: [],
      page: 1,
      disabled: false,
      errortype:this.$route.query.type || '',
      isFoot: false,
      name: this.$route.query.com,
      address: "",
      city:'',
      area:'',
      title: "选择您所在小区/社区",
      aroundWrapHeight: document.documentElement.clientHeight - 250,
      center: [121.59996, 31.197646],
      lng: 0,
      lat: 0,
      loaded: false,
      location: localStorage.getItem("lon") + "," + localStorage.getItem("lat")
    };
  },
  components: {
    Top
  },
  computed: {
    // location() {
    //     return localStorage.getItem('lon')+','+localStorage.getItem('lat')
    // }
  },
  created() {
    if (this.$route.query.address) {
      this.name = this.$route.query.com;
      this.address = this.$route.query.address;
    }
  },
  methods: {
    // 获取定位
    position() {
      let _this = this;
      _this.aroundList = [];
      location.getPosition(
        this.AMap,
        data => {
          // alert('进来了')
          _this.loaded = true;
          _this.lng = data.position.getLng();
          _this.lat = data.position.getLat();
          _this.location = _this.lng + "," + _this.lat;
          _this.page = 1;
          _this.aroundRoom(_this.page, _this.location);
        },
        error => {
          // alert("错误了")
          if(error.message=='Geolocation permission denied.') {
            Toast('请开启定位权限')
          }else{
            Toast(error.message)
          }
          // console.log(error);
        }
      );
    },
    // 进入搜索
    intoSearch() {
      this.$router.push({
        path: "/search"
      });
    },
    // 选中回到首页
    goBack(item) {
      let _this = this
      axios.post(this.commonIp()+"/v1/mobile/community/edit", {
          poiId: item.id,
          token: this.getuserToken()
      }).then(res => {
        this.$router.push({
          path: "/",
          query: {
            poiId: item.id,
            lng: item.location.split(",")[0],
            lat: item.location.split(",")[1]
          }
        });
      })
      localStorage.setItem("lon", item.location.split(",")[0]);
      localStorage.setItem("lat", item.location.split(",")[1]);
    },
    aroundRoom(page, location) {
      Indicator.open();
      this.disabled = true;
      axios
        .get(
          `https://restapi.amap.com/v3/place/around?key=${localStorage.getItem(
            "key"
          )}&page=${page}&location=${location}&radius=1000&types=120302|120201`
        )
        .then(res => {
          Indicator.close();
          let newPois = res.data.pois.filter(item => (item.id!="B000A844UJ" && item.id!="B0FFK4ECAV" && item.id!="B0FFFOZLJF"));
          // let newPois = res.data.pois;
          if (newPois.length != 0) {
            this.aroundList = this.aroundList.concat(newPois);
            this.name = this.aroundList[0].name
            this.address = this.aroundList[0].address
            this.city = this.aroundList[0].cityname
            this.area = this.aroundList[0].adname
            ++this.page;
            this.disabled = false;
            if (res.data.count < 20) {
              this.isFoot = true;
            }
          } else {
            this.disabled = true;
          }
        })
        .catch(error => {
          Indicator.close();
          if (page == 1) {
            return;
          }
          this.$refs.onetag.scrollTop =
            this.$refs.onetag.scrollTop - this.$refs.bottom.offsetHeight;
          this.disabled = false;
        });
    },
    loadMore() {
      // this.disabled = true
      this.aroundRoom(this.page, this.location);
    }
  }
};
</script>
<style lang="less">
@import "~@/assets/less/index.less";
#sqChioce {
  .line1 {
    height: 1px;
    width: 100%;
    background: #f2f2f2;
  }
  .searchBox {
    margin: 10px 15px 15px;
    height: 29px;
    line-height: 29px;
    color: #999;
    font-size: @ft14;
    background: url("~@/assets/imgs/s2.png") no-repeat 10px center #f2f2f2;
    background-size: 12px;
    padding: 0 0 0 33px;
    border-radius: 4px;
    border-top: 1px solid #f2f2f2;
  }
  .onetag {
    height: 100%;
    overflow: scroll;
  }
  .littleIcon {
    width: 13px;
    height: 13px;
  }
  p {
    padding: 0 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .title {
    font-size: @ft17;
    height: 45px;
    line-height: 45px;
    color: @fc32;
  }
  .cur {
    background: #f2f2f2;
    color: #969696;
    height: 43px;
    line-height: 43px;
  }
  .can {
    font-size: @ft13;
    color: #999;
    &.nearby {
      padding: 20px 0 10px 15px;
      border-bottom: 1px solid #d8d8d8;
    }
  }
  .nowRoom {
    li {
      padding: 15px;
      .title1 {
        padding: 0;
      }
      .title2 {
        max-width: 200px;
        .fl();
        display: inline-block;
      }
      .rep {
        .fr();
        padding-left: 17px;
        background: url("~@/assets/imgs/rd.png") no-repeat left center;
        background-size: 12px;
        color: #238dd4;
        font-size: @ft13;
        margin-top: 1.5px;
      }
      .address {
        font-size: @ft14;
        color: @fc32;
        display: inline-block;
        margin: 5px 0 0 0;
        color: @gray;
      }
    }
  }
  .aroundRoom {
    li {
      border-bottom: 1px solid #d8d8d8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chiocesq/chiocesq.vue